import {useRef} from 'react';
import {Button} from '@cvent/carina/components/Button';
import {Modal} from '@cvent/carina/components/Modal';
import {DismissButton} from '@cvent/carina/components/ScrollViewWithBars';

type InactiveUserModalProps = {
  handleClose: () => void;
};

const InactiveUserModal = ({handleClose}: InactiveUserModalProps) => {
  const headerRef = useRef<HTMLHeadingElement | null>(null);

  return (
    <Modal
      isOpen
      format="sm"
      onDismiss={handleClose}
      testID="inactive-user-modal"
      aria-labelledby="inactive-user-title"
    >
      <div className="flex flex-col box-border w-[420px] max-w-full p-6 pt-4">
        <div className="flex items-start justify-between">
          <h1
            id="inactive-user-title"
            ref={headerRef}
            tabIndex={-1}
            className="text-[length:var(--carina-font-size-display-xs)] font-[var(--carina-font-weight-display)] leading-[var(--carina-line-height-display-xs)] pt-1"
          >
            Contact Support!
          </h1>
          <DismissButton aria-label="Dismiss" onClick={handleClose} />
        </div>

        <div className="my-4 text-sm leading-[var(--carina-line-height-normal)] text-[var(--carina-text-color-soft)]">
          <p id="inactive-user-content">
            Your password could not be reset, contact our support team,{' '}
            <a
              aria-label="socialtables support email link"
              href="mailto:ST.support@cvent.com"
              className="text-[var(--carina-link-color,#006ae1)]"
            >
              ST.support@cvent.com
            </a>
            , or call{' '}
            <a
              aria-label="socialtables support phone number"
              href="tel:866-318-4357"
              className="text-[var(--carina-link-color,#006ae1)]"
            >
              866-318-4357
            </a>
            . Our phone support is available Monday through Friday, from 9 am to
            10 pm ET.
          </p>
        </div>

        <div className="my-4 flex justify-end">
          <Button
            text="Go to login"
            onClick={() => {
              window.location.href = '/new';
            }}
            type="button"
            appearance="filled"
          />
        </div>
      </div>
    </Modal>
  );
};

export default InactiveUserModal;
